// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import React from 'react'
import { func, object, string } from 'prop-types'
import usePathCartStoreContext from 'components/PathCart/hooks/usePathCartStoreContext'
import usePathCartActionsContext from 'components/PathCart/hooks/usePathCartActionsContext'

import {
  OpenInNewTab,
  PassiveTrigger,
  PathMenu,
} from 'components/PathSummary/components/CellFormatters/common'

const PathDbPathInfo = props => {
  const {
    columnKey,
    customProps,
    idRoot,
    rowData,
    TooltipTrigger,
  } = props

  const {
    renderOpenInNewTab,
    renderPathMenu,
  } = customProps

  const {
    band,
    passiveSummary,
    pathId,
    pathIndex,
    pathName,
    rcnNumber,
  } = rowData

  const pathCartStore = usePathCartStoreContext()

  const {
    addPathToCartStore,
    removePathById,
  } = usePathCartActionsContext()

  const pathIsInStore = !!pathCartStore.find(d => rowData.pathId === d.pathId)

  const handleClick = e => {
    e.stopPropagation()
    return (
      pathIsInStore
        ? removePathById(rowData.pathId)
        : addPathToCartStore(rowData)
    )
  }

  return (
    <div
      className={`path-summary-path-info-cell path-summary-cell ${pathIsInStore ? 'path-summary-selected' : ''}`}
      style={{ background: pathIsInStore ? '#fda130' : '#6cf' }}
      onClick={handleClick}
      title={`Path Id: ${pathId}`}>
      <div className={'path-summary-site-cell'}>
        <span
          data-label={'path-index'}
          id={`${idRoot}-path-index`}
          style={{ width: '30px' }}>
          {pathIndex}
        </span>
        <strong
          className={'text-ellipsis margin-right-auto'}
          data-label={'path-name'}
          id={`${idRoot}-path-name`}>
          {pathName}
        </strong>
        <span
          data-label={'path-band'}
          id={`${idRoot}-path-band`}>
          {band}
        </span>
      </div>
      <div className={'path-summary-site-cell'}>
        {
          renderPathMenu &&
          <PathMenu
            idRoot={`${idRoot}-path-menu-`}
            pathId={pathId} />
        }
        {
          renderOpenInNewTab &&
          <OpenInNewTab
            idRoot={idRoot}
            newPath={`/database-management/path/${pathId}`} />
        }
        <span
          className={'text-ellipsis margin-right-auto'}
          data-label={'path-rcn'}
          id={`${idRoot}-path-rcn`}>
          {rcnNumber}
        </span>
        <PassiveTrigger
          columnKey={columnKey}
          idRoot={idRoot}
          passiveSummary={passiveSummary}
          TooltipTrigger={TooltipTrigger} />
      </div>
    </div>
  )
}

PathDbPathInfo.propTypes = {
  columnKey: string.isRequired,
  customProps: object.isRequired,
  idRoot: string.isRequired,
  rowData: object.isRequired,
  TooltipTrigger: func.isRequired,
}

export default PathDbPathInfo
